module.exports = {
  token: null,
  company_code: null,
  browser_id: null,
  staging: false,
  params : {},

  unread_count: 0,
  is_show_notification: false,
  isPopupOpen: false,
  notify_content: 'Bạn có tin nhắn mới',

  required_field: {
    name: '',
    phone: '',
    mail: '',
    interest_content: ''
  },

  setting: {
    greeting: "",
    live_chat: {
      name: "",
      avatar: "",
      logo: "",
      description: ""
    },
    required_title: '',
    required_field: {
      name: { is_show: true, is_required: true },
      phone: { is_show: true, is_required: false },
      mail: { is_show: false, is_required: false },
      interest_content: { is_show: false, is_required: false }
    },
    questions_list: [],
    is_required_field: true
  }

}

// export default globalData;
